import React from "react";

const LOGO_URL =
  "https://media.base44.com/images/public/6a43d9d1a62810142073c016/3fbe2d0d0_professionalmembership25.png";

/**
 * ITDA-IHMP Professional Member emblem, pinned to the top-right corner of
 * registration pages. Hidden on very small screens to keep headers readable.
 */
export default function RegistrationLogo({ className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="ITDA-IHMP Professional Member"
      className={`w-20 h-20 sm:w-24 sm:h-24 object-contain drop-shadow-sm shrink-0 ${className}`}
    />
  );
}